import { useTranslation } from '@aimsos/i18n';

import NextBestActionSection from './NextBestActionSection.jsx';
import NextBestActionStepList from './NextBestActionStepList.jsx';
import NextBestActionWayCard from './NextBestActionWayCard.jsx';

/** "View details" of a suggestion: Source, Why, Ways to do it and Steps (CT-5713). */
function NextBestActionDetails({ item, entity, onAction }) {
  const { t } = useTranslation('unified-profiles');
  const { source, why, ways, steps } = item.details;

  return (
    <div className="flex flex-col gap-6">
      {source || why ? (
        <div className="flex flex-col gap-1 text-sm text-content-secondary">
          {source ? <span>{t('profile.nba.source', { source: source.label })}</span> : null}
          {why ? <span>{t('profile.nba.why', { why: why.label })}</span> : null}
        </div>
      ) : null}
      {ways.length ? (
        <NextBestActionSection title={t('profile.nba.ways')} testId="nba-ways">
          <div className="flex flex-col gap-3">
            {ways.map((way) => (
              <NextBestActionWayCard key={way.id} item={item} way={way} entity={entity} onAction={onAction} />
            ))}
          </div>
        </NextBestActionSection>
      ) : null}
      {steps.length ? (
        <NextBestActionSection title={t('profile.nba.steps')}>
          <NextBestActionStepList steps={steps} />
        </NextBestActionSection>
      ) : null}
    </div>
  );
}

export default NextBestActionDetails;
